// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add these styles to your existing GeneralSetting.module.css */

.GeneralSetting_tooltipContainer__DxNjn {
  position: relative;
  display: inline-block;
}

.GeneralSetting_tooltipText__-rnmr {
  visibility: hidden;
  width: 200px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%; /* Position above the button */
  left: 50%;
  margin-left: -100px; /* Center the tooltip */
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 14px;
  pointer-events: none;
}

.GeneralSetting_tooltipContainer__DxNjn:hover .GeneralSetting_tooltipText__-rnmr {
  visibility: visible;
  opacity: 1;
}

.GeneralSetting_disabledButton__YfoLq {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #ccc !important;
  color: #666 !important;
}
.GeneralSetting_container__-05hm {
  width: 100%;
  /* background-color: var(--white-color); */
  /* border-radius: 10px; */
  padding: 2rem;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
  height: 100%;
}

.GeneralSetting_title__NYc88 {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}
.GeneralSetting_content-wrapper__94-k1 {
  display: flex;
  flex-direction: column;
  /* align-items: flex-end; */
}
.GeneralSetting_saveButton__ha0TS {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background-color: var(--saveBtn);
  color: var(--white-color);
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  cursor: pointer;
  margin-bottom: 2rem;
}
.GeneralSetting_saveButton__ha0TS:hover{
  background-color: var(--saveHover);
}
.GeneralSetting_content__WrJmn {
  display: flex;
  /* flex-direction: row; */
  gap: 30px;
  align-items: center;
  justify-content: center;
}
.GeneralSetting_applyButtonContainer__zDWvV {
  text-align: right;
}
.GeneralSetting_keyLabel__TNyPn {
  font-weight: 500;
  color: #111827;
  margin-right: 4px;
  background-color: #f2f6ff;
  border: 1px solid #2563eb;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 75%;
  word-wrap: break-word;
  font-size: 16px;
}
.GeneralSetting_settings-cards__3Ej5b {
  /* display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem; */

  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.GeneralSetting_settingBox__iJMu2 {
   border-radius: 8px;
  padding: 20px;
  background: var(--white-color);
  box-shadow: var(--shadow-md);
}
.GeneralSetting_toggleText__bfapP {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  color: #1f2937;
}
.GeneralSetting_description__hUoyr {
  margin: 6px 0;
  font-size: 0.95rem;
  color: #444;
}
.GeneralSetting_nestedSettings__qWlWa .GeneralSetting_settingBox__iJMu2 {
  box-shadow: none;
}

.GeneralSetting_subtitle__osorZ {
  font-size: 1rem;
  font-weight: 500;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.GeneralSetting_nestedSettings__qWlWa {
  margin-top: 18px;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background-color: #e6edff;
  border: 1px solid #a3bdff;
}

.GeneralSetting_settingItem__e\\+gDi {
  /* padding: 14px; */
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* background-color: #e6edff;
  border: 1px solid #a3bdff; */
  border-radius: 8px;
}

.GeneralSetting_toggleButton__mWZKs {
  /* background-color: #3498db; */
  color: var(--white-color);
  border: none;
  padding: 0.4rem 0.75rem;
  font-size: 0.85rem;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 0.5rem;
  transition: background-color 0.2s ease-in-out;
}
.GeneralSetting_enabled__hIVjF:hover {
  background-color: #1850ca;
}
.GeneralSetting_numericSetting__8e8bY {
  margin-top: 0.75rem;
}

.GeneralSetting_numericControl__V5lwL {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.GeneralSetting_numericInputGroup__FgIJ5 {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.GeneralSetting_numericInputGroup__FgIJ5 input {
  width: 60px;
  text-align: center;
  padding: 0.25rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.GeneralSetting_numericInputGroup__FgIJ5 button {
  background-color: #f1f2f6;
  border: 1px solid #dcdde1;
  padding: 0.25rem 0.5rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.GeneralSetting_numericInputGroup__FgIJ5 button:hover {
  background-color: #dcdde1;
}

.GeneralSetting_applyButtonContainer__zDWvV {
  display: flex;
  justify-content: flex-end;
}

.GeneralSetting_applyButton__VrCHr {
  background-color: #27ae60;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
}

.GeneralSetting_applyButton__VrCHr:hover {
  background-color: #219653;
}

/* .nestedSettings .settingBox {
  max-width: 200px;
  margin-bottom: 0px;
}
.nestedSettings .settingBox:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
} */
.GeneralSetting_enabled__hIVjF {
  background-color: #2563eb;
}

.GeneralSetting_disabled__Lt9fQ {
  background-color: #bac3ce;
  /* cursor: not-allowed; */
  color: rgb(66, 66, 66);
}

/* .toggleButton:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
} */

@media (max-width: 480px) {
  .GeneralSetting_container__-05hm {
    flex-direction: column;
    padding: 16px;
  }
  .GeneralSetting_title__NYc88 {
    font-size: 1.4rem;
  }
  .GeneralSetting_saveButton__ha0TS {
    width: 100%;
  }
  .GeneralSetting_settingItem__e\\+gDi {
    flex-direction: column;
  }
  .GeneralSetting_toggleText__bfapP {
    text-align: left;
    flex-direction: column;
  }
  .GeneralSetting_keyLabel__TNyPn {
    font-weight: 600;
    background: transparent;
    border: none;
    border-bottom: 1px solid #2563eb;
    border-radius: 0px;
    max-width: 100%;
    padding: 0px 0px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/GeneralSettings/GeneralSetting.module.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,8BAA8B;EAC5C,SAAS;EACT,mBAAmB,EAAE,uBAAuB;EAC5C,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE;;gBAEc;;EAEd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;GACG,kBAAkB;EACnB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;8BAC4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;AACH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,oBAAoB;EACtB;AACF","sourcesContent":["/* Add these styles to your existing GeneralSetting.module.css */\n\n.tooltipContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltipText {\n  visibility: hidden;\n  width: 200px;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%; /* Position above the button */\n  left: 50%;\n  margin-left: -100px; /* Center the tooltip */\n  opacity: 0;\n  transition: opacity 0.3s;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.tooltipContainer:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n}\n\n.disabledButton {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #ccc !important;\n  color: #666 !important;\n}\n.container {\n  width: 100%;\n  /* background-color: var(--white-color); */\n  /* border-radius: 10px; */\n  padding: 2rem;\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n  height: 100%;\n}\n\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  /* align-items: flex-end; */\n}\n.saveButton {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n  cursor: pointer;\n  margin-bottom: 2rem;\n}\n.saveButton:hover{\n  background-color: var(--saveHover);\n}\n.content {\n  display: flex;\n  /* flex-direction: row; */\n  gap: 30px;\n  align-items: center;\n  justify-content: center;\n}\n.applyButtonContainer {\n  text-align: right;\n}\n.keyLabel {\n  font-weight: 500;\n  color: #111827;\n  margin-right: 4px;\n  background-color: #f2f6ff;\n  border: 1px solid #2563eb;\n  padding: 8px 12px;\n  border-radius: 8px;\n  max-width: 75%;\n  word-wrap: break-word;\n  font-size: 16px;\n}\n.settings-cards {\n  /* display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem; */\n\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n.settingBox {\n   border-radius: 8px;\n  padding: 20px;\n  background: var(--white-color);\n  box-shadow: var(--shadow-md);\n}\n.toggleText {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.95rem;\n  color: #1f2937;\n}\n.description {\n  margin: 6px 0;\n  font-size: 0.95rem;\n  color: #444;\n}\n.nestedSettings .settingBox {\n  box-shadow: none;\n}\n\n.subtitle {\n  font-size: 1rem;\n  font-weight: 500;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  color: #2c3e50;\n}\n\n.nestedSettings {\n  margin-top: 18px;\n  padding: 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background-color: #e6edff;\n  border: 1px solid #a3bdff;\n}\n\n.settingItem {\n  /* padding: 14px; */\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* background-color: #e6edff;\n  border: 1px solid #a3bdff; */\n  border-radius: 8px;\n}\n\n.toggleButton {\n  /* background-color: #3498db; */\n  color: var(--white-color);\n  border: none;\n  padding: 0.4rem 0.75rem;\n  font-size: 0.85rem;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-top: 0.5rem;\n  transition: background-color 0.2s ease-in-out;\n}\n.enabled:hover {\n  background-color: #1850ca;\n}\n.numericSetting {\n  margin-top: 0.75rem;\n}\n\n.numericControl {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.25rem;\n}\n\n.numericInputGroup {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.numericInputGroup input {\n  width: 60px;\n  text-align: center;\n  padding: 0.25rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.numericInputGroup button {\n  background-color: #f1f2f6;\n  border: 1px solid #dcdde1;\n  padding: 0.25rem 0.5rem;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.numericInputGroup button:hover {\n  background-color: #dcdde1;\n}\n\n.applyButtonContainer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.applyButton {\n  background-color: #27ae60;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.applyButton:hover {\n  background-color: #219653;\n}\n\n/* .nestedSettings .settingBox {\n  max-width: 200px;\n  margin-bottom: 0px;\n}\n.nestedSettings .settingBox:hover {\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n} */\n.enabled {\n  background-color: #2563eb;\n}\n\n.disabled {\n  background-color: #bac3ce;\n  /* cursor: not-allowed; */\n  color: rgb(66, 66, 66);\n}\n\n/* .toggleButton:disabled {\n  background-color: #94a3b8;\n  cursor: not-allowed;\n} */\n\n@media (max-width: 480px) {\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n  .title {\n    font-size: 1.4rem;\n  }\n  .saveButton {\n    width: 100%;\n  }\n  .settingItem {\n    flex-direction: column;\n  }\n  .toggleText {\n    text-align: left;\n    flex-direction: column;\n  }\n  .keyLabel {\n    font-weight: 600;\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid #2563eb;\n    border-radius: 0px;\n    max-width: 100%;\n    padding: 0px 0px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `GeneralSetting_tooltipContainer__DxNjn`,
	"tooltipText": `GeneralSetting_tooltipText__-rnmr`,
	"disabledButton": `GeneralSetting_disabledButton__YfoLq`,
	"container": `GeneralSetting_container__-05hm`,
	"title": `GeneralSetting_title__NYc88`,
	"content-wrapper": `GeneralSetting_content-wrapper__94-k1`,
	"saveButton": `GeneralSetting_saveButton__ha0TS`,
	"content": `GeneralSetting_content__WrJmn`,
	"applyButtonContainer": `GeneralSetting_applyButtonContainer__zDWvV`,
	"keyLabel": `GeneralSetting_keyLabel__TNyPn`,
	"settings-cards": `GeneralSetting_settings-cards__3Ej5b`,
	"settingBox": `GeneralSetting_settingBox__iJMu2`,
	"toggleText": `GeneralSetting_toggleText__bfapP`,
	"description": `GeneralSetting_description__hUoyr`,
	"nestedSettings": `GeneralSetting_nestedSettings__qWlWa`,
	"subtitle": `GeneralSetting_subtitle__osorZ`,
	"settingItem": `GeneralSetting_settingItem__e+gDi`,
	"toggleButton": `GeneralSetting_toggleButton__mWZKs`,
	"enabled": `GeneralSetting_enabled__hIVjF`,
	"numericSetting": `GeneralSetting_numericSetting__8e8bY`,
	"numericControl": `GeneralSetting_numericControl__V5lwL`,
	"numericInputGroup": `GeneralSetting_numericInputGroup__FgIJ5`,
	"applyButton": `GeneralSetting_applyButton__VrCHr`,
	"disabled": `GeneralSetting_disabled__Lt9fQ`
};
export default ___CSS_LOADER_EXPORT___;
